// extracted by mini-css-extract-plugin
export default {"home":"home_home__5V0PT","content":"home_content__eWjaY"};